import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { BreakpointMonitorService } from "../services/breakpoint-monitor.service";
import { Product, ProductService } from "../services/product.service";

@Component({
  standalone: false,
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit, OnDestroy {
  public selectedProduct: Product;
  public screenSmall$ = new Observable<boolean>;

  constructor(
    public productService: ProductService,
    public breakpointMonitor: BreakpointMonitorService
  ) {
  }

  ngOnInit(): void {
    this.screenSmall$ = this.breakpointMonitor.screenSmall$;
    const products = this.productService.getProducts();
    if (products.length > 0) {
      this.onProductSelection(products[0]);
    }
  }

  onProductSelection(selectedProduct: Product): void {
    this.selectedProduct = selectedProduct;
  };

  ngOnDestroy(): void {
  };
}
